module.exports = __webpack_public_path__ + "img/3.ea71d81e.png";